export default class DocumentService {

    public static setTitle = (title: string) => {
        document.title = `MOVE - ${title}`
    }
}